import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-screen text-center bg-primary-50" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "absolute inset-0 flex items-center justify-center" }
const _hoisted_4 = { class: "text-2xl font-bold text-primary-500" }
const _hoisted_5 = { class: "mt-6 text-xl font-semibold text-primary-800" }
const _hoisted_6 = { class: "typing-effect" }

import { ref, watch, onMounted } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import type { LoadingStage } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingComponent',
  props: {
    stage: {},
    progress: {}
  },
  setup(__props: any) {

const props = __props;

const loadingMessage = ref("");
const displayedMessage = ref("");

const updateLoadingState = (stage: LoadingStage) => {
  switch (stage) {
    case "references":
      loadingMessage.value = "참조 자료를 수집하는 중...";
      break;
    case "generating":
      loadingMessage.value = "포스트를 생성하는 중...";
      break;
    case "finalizing":
      loadingMessage.value = "최종 결과를 준비하는 중...";
      break;
    default:
      loadingMessage.value = "준비 중...";
  }
  displayedMessage.value = loadingMessage.value;
};

// 초기 로딩 메시지 설정
onMounted(() => {
  updateLoadingState(props.stage);
});

watch(
  () => props.stage,
  (newStage) => {
    updateLoadingState(newStage);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ProgressSpinner), {
        style: {"width":"100px","height":"100px"},
        strokeWidth: "4",
        fill: "var(--surface-ground)",
        animationDuration: ".5s"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.progress) + "%", 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(displayedMessage.value), 1)
    ])
  ]))
}
}

})